// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:58:31

export default {
  "id": "snake-classic",
  "slug": "snake-classic",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/2609b48eea7d40ebb414a1211dfed2af-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/2609b48eea7d40ebb414a1211dfed2af/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Snake Classic",
      "description": "Snake Classic: A modern twist on the nostalgic snake game. Navigate your snake through six unique modes: Classic, Box, Tunnel, Mill, Condo, and Rail. Collect fruits and gems, customize your snake with skins, and enjoy multi-language support. Compete on personal leaderboards and play on both PC and mobile. Fun and engaging for all ages!",
      "instructions": "Objective: Control your snake to collect fruit and gems while avoiding collisions with walls and your own tail.\n\nPC Controls:\n\nMovement: Use the WASD keys or Arrow keys to control the direction of the snake.\n\nMouse Control: Swipe with your mouse in the direction you want the snake to move.\n\nMobile Controls:\n\nSwipe: Swipe up, down, left, or right on the screen to control the direction of the snake.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "arcade",
        "classic",
        "retro",
        "singleplayer",
        "snake"
      ]
    },
    "zh-CN": {
      "title": "经典贪吃蛇",
      "description": "经典蛇游戏：一款怀旧蛇游戏的现代改编。在六种独特模式中导航你的蛇：经典、盒子、隧道、磨坊、公寓和轨道。收集水果和宝石，用皮肤定制你的蛇，享受多语言支持。在个人排行榜上竞争，并在PC和移动设备上游戏。适合所有年龄段的乐趣和参与！",
      "instructions": "目标：控制你的蛇收集水果和宝石，同时避免撞到墙壁和自己的尾巴。\n\nPC控制：\n\n移动：使用WASD键或方向键来控制蛇的移动方向。\n\n鼠标控制：将鼠标向你想让蛇移动的方向滑动。\n\n移动端控制：\n\n滑动：在屏幕上向上、下、左或右滑动来控制蛇的移动方向。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "街机",
        "经典",
        "复古",
        "单人",
        "贪吃蛇"
      ]
    },
    "zh-TW": {
      "title": "經典蛇遊戲",
      "description": "Snake Classic：對懷舊蛇遊戲的現代變奏。透過六種獨特的模式操縱蛇進行遊戲：經典、盒子、隧道、磨坊、公寓和鐵軌。收集水果和宝石，用皮膚定製你的蛇，並享受多語言支援。在個人排行榜上競賽，並可在PC和行動設備上遊玩。適合所有年齡的有趣且引人入勝遊戲！",
      "instructions": "目標：控制你的蛇去收集水果和珠寶，同時避免撞到牆壁和自己的尾巴。\n\nPC操控：\n\n移動：使用WASD鍵或方向鍵來控制蛇的方向。\n\n滑鼠操控：將滑鼠向你要蛇移動的方向滑動。\n\n行動電話操控：\n\n滑動：在螢幕上向上、向下、向左或向右滑動來控制蛇的方向。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "電子遊戲",
        "經典",
        "復古",
        "單人遊戲",
        "蟒蛇"
      ]
    },
    "zh-HK": {
      "title": "經典蟲蛇遊戲",
      "description": "經典蛇遊戲：對經典蛇遊戲的現代風格重新解讀。透過六種獨特模式操控蛇進行遊戲：經典、箱、隧道、磨坊、高尚住宅區及鐵軌。收集水果和寶石，為蛇換上各種外殼，並享受多語言支援。在個人排行榜上競爭，並可在PC及手機上遊玩。適合各個年齡層，好玩的遊戲！",
      "instructions": "目標：控制你的蛇去收集水果和寶石，同時避免與牆壁和自己的尾巴碰撞。\n\nPC操作：\n\n移動：使用WASD鍵或方向鍵來控制蛇的移動方向。\n\n滑鼠控制：將滑鼠向你要蛇移動的方向滑動。\n\n移動電話控制：\n\n滑動：在螢幕上向上、向下、向左或向右滑動以控制蛇的移動方向。",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "電玩",
        "經典",
        "復古",
        "單人遊戲",
        "蜈蚣"
      ]
    },
    "ja": {
      "title": "スネーククラシック",
      "description": "Snake Classic: 怀旧の蛇ゲームに現代的な仕掛けを加えたもの。蛇を6つのユニークなモード（クラシック、ボックス、トンネル、ミル、コンドミニアム、レール）を通して操縦し、果物や宝石を収集し、スキンで蛇をカスタマイズし、多言語サポートを楽しみましょう。パーソナルリーダーボードで競い合い、PCおよびモバイルで遊べます。全ての年齢層に楽しめる！",
      "instructions": "目標: 範囲内を動くスネークを操り、果物と宝石を集めながら壁や自分の尾とぶつからないようにする。\n\nPCのコントロール：\n\n移動：WASDキーや矢印キーを使用してスネークの方向を制御。\n\nマウスコントロール：マウスで欲しい方向にスワイプ。\n\nモバイルコントロール：\n\nスワイプ：スクリーンに上、下、左、右にスワイプしてスネークの方向を制御。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "アーケード",
        "クラシック",
        "レトロ",
        "シングルプレイヤー",
        "スネーク"
      ]
    },
    "ko": {
      "title": "사네 클래식",
      "description": "snake classic: 기억에 남는 뱀 게임에 현대적인 변신. 뱀을 여섯 가지 독특한 모드를 통해 이동하세요: 클래식, 박스, 터널, 밀, 콘도, 레일. 과일과 보석을 수집하고, 스킨으로 뱀을 사용자 정의하세요. 다양한 언어 지원을 통해 즐겨보세요. 개인 랭킹에서 경쟁하고, PC와 모바일에서 모두 플레이하세요. 모든 연령대에 적합한 재미와 매력적입니다!",
      "instructions": "목표: 뱀을 조종하여 과일과 보석을 모으고 벽과 자신의 꼬리와의 충돌을 피하세요.\n\nPC 조작:\n\n이동: WASD 키나 방향 키를 사용하여 뱀의 방향을 조종하세요.\n\n마우스 조작: 마우스로 원하는 방향으로 스와이프하세요.\n\n모바일 조작:\n\n스와이프: 화면에서 위, 아래, 왼쪽, 또는 오른쪽으로 스와이프하여 뱀의 방향을 조종하세요.",
      "genres": [
        "캐주얼",
        "패uzzle"
      ],
      "tags": [
        "어거트",
        "클래식",
        "레트로",
        "싱글플레이어",
        "스네이크"
      ]
    },
    "fr": {
      "title": "Snake Classique",
      "description": "Snake Classic : Une version moderne du classique jeu de serpent. Parcourez votre serpent à travers six modes uniques : Classique, Boîte, Tunnel, Moulin, Condo et Rail. Collectez des fruits et des gemmes, personnalisez votre serpent avec des skins et profitez du support multilingue. Concurrence sur les classements personnels et jouabilité sur PC et mobile. Amusant et captivant pour tous les âges !",
      "instructions": "Objectif : Contrôlez votre serpent pour ramasser des fruits et des pierres précieuses tout en évitant les collisions avec les murs et votre propre queue.\n\nContrôles PC :\n\nMouvement : Utilisez les touches WASD ou les flèches pour contrôler la direction du serpent.\n\nContrôle de la souris : Faites glisser la souris dans la direction dans laquelle vous voulez que le serpent se déplace.\n\nContrôles Mobiles :\n\nGlisser : Glissez vers le haut, le bas, la gauche ou la droite de l'écran pour contrôler la direction du serpent.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "arcade",
        "classique",
        "retro",
        "solo",
        "serpent"
      ]
    }
  }
};
